module.exports = __webpack_public_path__ + "img/grey.6813afc0.svg";